module.exports = __webpack_public_path__ + "images/5e540b0c2beb5d4eae4a26f9de099658.png";